import React, {useEffect, useState} from 'react';
import { StyledTitle } from './custom-styled-components/_MyCustomSC';
import "../../CSS/Grid.css"
import PropTypes from 'prop-types';
import { Select, Form } from 'antd';
import { isEmpty } from '../../util/isEmpty';
import CustomDropdownRender from '../common/CustomDropdownRender';
import { isDevENV } from '../../util/isDevENV';
import {connect} from "react-redux";
import * as actions from "../../actions";
const { Option } = Select;

const SHOW_RULES = false; //for showing validation error in production, make it 'true'

/**
 * @component
 * @category Form Page
 * @name ExistingFactoryDropdown
 * @description dropdown for selecting an existing factory
 * <br> <br>
 * **Example**
 * ```js
 *
 *
 *<ExistingFactoryDropdown existingFactoryListArrIndex={null} onExistingFactorySelectChange={() => {}} data={{}} />
 * ```
 */
const SelectFactory = (props) => {
  // const data = props.data && props.data['factory_list'];
  const data = props.data
  const existingFactoryListArrIndex = props.existingFactoryListArrIndex ;
  const oldSelctedOptionObj =
    existingFactoryListArrIndex !== null &&
    data &&
    data[existingFactoryListArrIndex];
  let oldSelectedOptionName = oldSelctedOptionObj && oldSelctedOptionObj.name;
  // console.log('ExistingFactoryDropdown data: ', data);

  const [scrollPosition, setScrollPosition] = useState(0);
  // useEffect(() => {
  //  //props.form.validateFields();
  //   props.form.validateFields((err, values) => {
  //     console.log("----SELECT FORM VALUES: ",values)
  //   })
  // }, []);


  const handleScroll = (event) => {
    const  scrollTop  = event.target;
    setScrollPosition(scrollTop);
  };

  const {
    selectedPickupExistingFactoryJson,
    selectedDeliveryExistingFactoryJson,
    isPickupFactory,
    changeDrop,
    transaction_type,
    final_view_after_submit
  } = props;


  const selectedExistingFactoryJson = isPickupFactory
      ? selectedPickupExistingFactoryJson
      : selectedDeliveryExistingFactoryJson;
  return (
    <span>
      {/*<StyledTitle>Select factory </StyledTitle>*/}
      <Form className='factory-input-width'>
        <Form.Item style={{marginBottom:'0px'}}
        >
          {/* {getFieldDecorator('existing-factory', {
            //initialValue: oldSelectedOptionName || undefined,
            rules: [{ required: SHOW_RULES, message: 'Required' }],
          })( */}
            <Select
              style={{width:"100%"}}
              loading = {props?.loadingPostalCode}
              placeholder=  {
              transaction_type === 'Importer' ?   
                isPickupFactory ? (Object.keys(selectedExistingFactoryJson).length>0?selectedExistingFactoryJson.name:"Select Shipper") :
                (Object.keys(selectedExistingFactoryJson).length>0?selectedExistingFactoryJson.name:"Select Delivery Location")
              :
              isPickupFactory ? (Object.keys(selectedExistingFactoryJson).length>0?selectedExistingFactoryJson.name:"Select Pickup Location") :
              (Object.keys(selectedExistingFactoryJson).length>0?selectedExistingFactoryJson.name:"Select Receiver")
              }
              value={selectedExistingFactoryJson.name}
              onChange={props.onExistingFactorySelectChange}
              onPopupScroll={handleScroll}
              dropdownRender={(menu) => {
                return (
                  <div>
                    {!isEmpty(data) ? (
                      menu
                    ) : (
                      <CustomDropdownRender showSpin={true} />
                    )}
                  </div>
                );
              }
            }
            >
              <Option
                  style={{ position: 'sticky', top: ''+scrollPosition+'px' ,color:'white', background:'black' }}
                  value='new' key='New'>
                Add New {props.isPickupFactory ? (transaction_type === 'Importer' ? "Shipper" : "Pickup Location") : (transaction_type === 'Importer' ? "Delivery Location" : "Receiver")}
              </Option>


              {Array.isArray(data) && data.map((factory, index) => (
                  <Option
                      value={factory.id} key={`${factory.name}, ${index}`}>
                    {factory.name}
                  </Option>
                ))}
            </Select>


          {/* )} */}

        </Form.Item>
      </Form>
    </span>
  );
};

const ExistingFactoryDropdown = Form.create({
  name: 'select-an-existing-factory',
})(SelectFactory);

SelectFactory.propTypes = {
  /**
   * array index (starts from zero) of selected pickup/delivery existing factory in the list of factories.
   * It also accepts `null`
   */
  existingFactoryListArrIndex: PropTypes.number,

  /**
   * when an existing factory dropdown is selected, this method is invoked
   */
  onExistingFactorySelectChange: PropTypes.func,
  /**
   *  pickup/delivery existing factory json
   */
  data: PropTypes.object,
};

const mapStateToProps = (state) => {
  const { pickup, delivery } = state.form;
  const { transactionType } = state.code_config;

  // Swap values based on transaction_type
  const pickupExistingFactoryJson = transactionType === 'Exporter'
    ? delivery.existingFactoryJson
    : pickup.existingFactoryJson;

  const deliveryExistingFactoryJson = transactionType === 'Exporter'
    ? pickup.existingFactoryJson
    : delivery.existingFactoryJson;
  return {
    pickupExistingFactoryJson,
    deliveryExistingFactoryJson,
    showFormValidation: state.form.showFormValidation,
    know_users_details:state.route.User_factor_and_shipper_Details,
    deliveryFactoryInfo: state.form.factoryInfo.delivery,
    pickupFactoryInfo: state.form.factoryInfo.pickup,
    // :state.form.Update_Factory_select,
    selectedPickupExistingFactoryJson:
    state.form.pickup.selectedExistingFactoryJson,
    selectedDeliveryExistingFactoryJson:
    state.form.delivery.selectedExistingFactoryJson,
    final_view_after_submit:state.form.final_view_after_submit,
    transaction_type: state.code_config.transactionType,

  };
};

export default connect(mapStateToProps, actions)(ExistingFactoryDropdown);


